import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/svg/Icon_Document-Check.svg'
import _imports_1 from '../../assets/svg/icon_Trash.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "data-rectangle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "IconDocument-Check",
    alt: "document check icon"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "data-oval" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "data-modal-content"
}
const _hoisted_3 = { class: "data-modal-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "data-modal-title font-bold" }, "Raw Data Request", -1)
const _hoisted_5 = { class: "data-modal-paragraph font-reg font-16" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("In order to proceed with your raw data request you need to ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" for a SMARTplus account. Only then, will you be able to proceed.")
const _hoisted_9 = { class: "raw-data-title" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("You have requested the raw data for the following ")
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" surveys:")
const _hoisted_13 = { class: "raw-data-header light-grey-bg" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" SURVEY NAME ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" LOCATION ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" DATE ")
const _hoisted_17 = { class: "raw-data-footer-buttons font-med" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Sign In ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Sign Up ")
const _hoisted_21 = {
  key: 1,
  class: "data-modal-content"
}
const _hoisted_22 = { class: "data-modal-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h1", { class: "data-modal-title font-bold" }, "Raw Data Request", -1)
const _hoisted_24 = { class: "step-indicator" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("1 Confirm Surveys")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("2 Study Details")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("3 Collaborators")
const _hoisted_28 = { class: "raw-data-title" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("You have requested the raw data for the following ")
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" surveys:")
const _hoisted_32 = { class: "raw-data-header light-grey-bg" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" SURVEY NAME ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" LOCATION ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" DATE ")
const _hoisted_36 = { class: "raw-data-footer-buttons font-med" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_39 = {
  key: 2,
  class: "data-modal-content"
}
const _hoisted_40 = { class: "data-modal-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h1", { class: "data-modal-title font-bold" }, "Raw Data Request", -1)
const _hoisted_42 = { class: "step-indicator" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("1 Confirm Surveys")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("2 Study Details")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("3 Collaborators")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "input-label-title" }, [
  /*#__PURE__*/_createTextVNode("RESEARCH/PROJECT TITLE"),
  /*#__PURE__*/_createElementVNode("a", { color: "red" }, "*")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "input-label-title" }, [
  /*#__PURE__*/_createTextVNode("RESEARCH/PROJECT DESCRIPTION"),
  /*#__PURE__*/_createElementVNode("a", { color: "red" }, "*")
], -1)
const _hoisted_48 = { class: "counter" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Word Count: ")
const _hoisted_50 = { class: "counter-bold" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("/3000")
const _hoisted_52 = { class: "raw-data-footer-buttons font-med" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_56 = {
  key: 3,
  class: "data-modal-content"
}
const _hoisted_57 = { class: "data-modal-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h1", { class: "data-modal-title font-bold" }, "Raw Data Request", -1)
const _hoisted_59 = { class: "step-indicator" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("1 Confirm Surveys")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("2 Study Details")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("3 Collaborators")
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h1", { class: "font-16 raw-data-title font-bold" }, "Add Collaborators (optional)", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "collaborator-txt" }, "Add any collaborators in your study who will have access to this data. You may skip this step by leaving the fields empty and clicking on submit request.", -1)
const _hoisted_65 = {
  key: 0,
  class: "input-label-title"
}
const _hoisted_66 = {
  key: 0,
  class: "input-label-title"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "raw-data-footer-buttons font-med" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Submit Request ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_List = _resolveComponent("List")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "confirm-loading": _ctx.confirmLoading,
    closable: false,
    onCancel: _ctx.handleClose,
    bodyStyle: {"padding": "0"},
    width: "48.8rem",
    footer: null
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("button", {
                  class: "font-med signin-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSignIn && _ctx.handleSignIn(...args)))
                }, "Sign In"),
                _hoisted_7,
                _createElementVNode("a", {
                  class: "font-med",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSignUp && _ctx.handleSignUp(...args)))
                }, "Sign Up"),
                _hoisted_8
              ])
            ]),
            _createElementVNode("p", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedSurveys.length), 1),
              _hoisted_12
            ]),
            _createVNode(_component_List, {
              class: "list-style",
              size: "small",
              bordered: "",
              "data-source": _ctx.selectedSurveysDetail
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Row, { class: "raw-data-header-text font-bold font-14" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              renderItem: _withCtx((item) => [
                _createVNode(_component_Row, { class: "raw-data-item raw-data-row table-font" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.surveyName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.administrative_area_level_2) + ", " + _toDisplayString(item.item.administrative_area_level_1) + ", " + _toDisplayString(item.item.geographicCountry), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.surveyMonthName) + " " + _toDisplayString(item.item.surveyYear), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["data-source"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "cancel",
                onClick: _ctx.handleClose
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button data-modal-button-sign-spacing",
                key: "sign-in",
                onClick: _ctx.handleSignIn
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "sign-up",
                type: "primary",
                onClick: _ctx.handleSignUp
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.isLogin && _ctx.currentStage===_ctx.Stage.CONFIRM_SURVEYS))
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Row, { style: {"margin-left":"8rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Col, { class: "raw-data-col font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("p", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.selectedSurveys.length), 1),
              _hoisted_31
            ]),
            _createVNode(_component_List, {
              size: "small",
              bordered: "",
              "data-source": _ctx.selectedSurveysDetail
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Row, { class: "raw-data-header-text font-bold font-14" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              renderItem: _withCtx((item) => [
                _createVNode(_component_Row, { class: "raw-data-item raw-data-row table-font" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.surveyName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.administrative_area_level_2) + ", " + _toDisplayString(item.item.administrative_area_level_1) + ", " + _toDisplayString(item.item.geographicCountry), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.item.surveyMonthName) + " " + _toDisplayString(item.item.surveyYear), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["data-source"]),
            _createVNode(_component_Alert, {
              class: "alert-warning",
              message: "Please validate the list of surveys",
              description: "Upon confirmation, you can't modify your selection of surveys.",
              type: "info",
              "show-icon": ""
            }),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "cancel",
                onClick: _ctx.handleClose
              }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button data-modal-button-continue-spacing",
                key: "sign-up",
                type: "primary",
                onClick: _ctx.handleContinue
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.isLogin && _ctx.currentStage===_ctx.Stage.STUDY_DETAILS))
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_Row, { style: {"margin-left":"8rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_46,
            _createVNode(_component_Input, {
              value: _ctx.researchTitle,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.researchTitle) = $event)),
              class: "input-box",
              size: "large",
              placeholder: "Placeholder"
            }, null, 8, ["value"]),
            _hoisted_47,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.researchDescription) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wordsLimit($event.target.value))),
              class: "textarea-box",
              size: "large",
              placeholder: "Placeholder"
            }, null, 544), [
              [_vModelText, _ctx.researchDescription]
            ]),
            _createElementVNode("p", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(`${_ctx.researchDescription}`.split(' ').filter(word => word !== '').length), 1),
              _hoisted_51
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "cancel",
                onClick: _ctx.handleClose
              }, {
                default: _withCtx(() => [
                  _hoisted_53
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button data-modal-button-sign-spacing",
                key: "back",
                onClick: _ctx.handleBack
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button",
                disabled: !(_ctx.researchTitle && _ctx.researchDescription),
                key: "sign-up",
                type: "primary",
                onClick: _ctx.handleContinue
              }, {
                default: _withCtx(() => [
                  _hoisted_55
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.isLogin && _ctx.currentStage===_ctx.Stage.COLLABORATORS))
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_Row, { style: {"margin-left":"8rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_60
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col-disabled font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Col, { class: "raw-data-col font-16" }, {
                      default: _withCtx(() => [
                        _hoisted_62
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_63,
            _hoisted_64,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collaborators, (item, index) => {
              return (_openBlock(), _createBlock(_component_Row, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { class: "row-info" }, {
                    default: _withCtx(() => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, "FULL NAME"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Input, {
                        value: item.fullName,
                        "onUpdate:value": ($event: any) => ((item.fullName) = $event),
                        class: "input-box",
                        size: "large",
                        placeholder: "Placeholder"
                      }, null, 8, ["value", "onUpdate:value"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Col, { class: "row-info" }, {
                    default: _withCtx(() => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, "EMAIL"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Input, {
                        value: item.email,
                        "onUpdate:value": ($event: any) => ((item.email) = $event),
                        class: "input-box",
                        size: "large",
                        placeholder: "Placeholder"
                      }, null, 8, ["value", "onUpdate:value"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("img", {
                    class: _normalizeClass([index === 0 ? 'first-clickable': 'clickable']),
                    onClick: ($event: any) => (_ctx.deleteCollaborator(index)),
                    src: _imports_1,
                    alt: "trash icon"
                  }, null, 10, _hoisted_67)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_Row, { style: {"margin-top":"2rem"} }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addCollaborator && _ctx.addCollaborator(...args))),
                  class: "add-icon clickable"
                }, "+"),
                _createElementVNode("p", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addCollaborator && _ctx.addCollaborator(...args))),
                  class: "clickable"
                }, "Add Row")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_68, [
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "cancel",
                onClick: _ctx.handleClose
              }, {
                default: _withCtx(() => [
                  _hoisted_69
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button data-modal-button-sign-spacing",
                key: "back",
                onClick: _ctx.handleBack
              }, {
                default: _withCtx(() => [
                  _hoisted_70
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "data-modal-button",
                key: "sign-up",
                type: "primary",
                onClick: _ctx.handleSubmitRequest
              }, {
                default: _withCtx(() => [
                  _hoisted_71
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "onCancel"]))
}